export enum NoteTypeEnum {
	Note = 'note',
	Activity = 'activity',
}
